import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Customer calls your restaurant like always",
    body: "Nothing changes for your guests. They dial the same number they always have and the phone gets answered right away.",
  },
  {
    n: "02",
    title: "AI assistant answers, takes the order accurately",
    body: "A natural-sounding assistant greets the caller, listens, and takes the full order, repeating it back to get every detail right.",
  },
  {
    n: "03",
    title: "The order lands right in your POS",
    body: "Each finished order shows up in your POS, ready for the kitchen, with no typing or relaying, so your team can start cooking right away.",
  },
];

const HowItWorks = () => {
  return (
    <section className="relative py-24 md:py-32 border-t border-line" data-testid="how-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mb-16 md:mb-28"
        >
          <span className="text-terra font-heading text-sm font-semibold tracking-widest uppercase">How it works</span>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-cream">
            Three steps. Zero change to your routine.
          </h2>
        </motion.div>

        <div className="flex flex-col gap-16 md:gap-24">
          {steps.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-120px" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 items-start border-b border-line pb-16 md:pb-24 last:border-0 last:pb-0"
              data-testid={`step-${i}`}
            >
              <div className="md:col-span-4">
                <span className="font-heading text-7xl sm:text-8xl md:text-9xl font-bold tracking-tighter text-terra leading-none">
                  {s.n}
                </span>
              </div>
              <div className="md:col-span-8 md:pt-4">
                <h3 className="font-heading text-2xl sm:text-3xl md:text-4xl font-medium text-cream tracking-tight leading-tight">
                  {s.title}
                </h3>
                <p className="mt-5 max-w-xl text-base sm:text-lg text-sand leading-relaxed">{s.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
